
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setCarcaseColour = (carcaseColour: libTypes.Order['carcaseColour']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.carcaseColour = fns.order.set.carcaseColour(carcaseColour);
        })
    });
};